import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import ArrowOut from '../icon/arrow-out'
import ArrowRight from '../icon/arrow-right'
import Check from './icon/check'
import Close from './icon/close'
import { Link } from 'react-router'

const buttonVariants = cva('', {
  variants: {
    colour: {
      'ink-blue':
        'text-blue-d stroke-blue-d border-blue-d/40 dark:text-white dark:stroke-white dark:border-white/60',
      'mid-blue':
        'text-blue-d stroke-blue-m border-blue-m/40 dark:text-white dark:stroke-white dark:border-white/60',
      white: 'text-white hover:text-white! stroke-white border-white/60',
      green: 'stroke-[#008767] text-blue-d border-[#008767]/40',
      red: 'stroke-[#EE0000] text-blue-d border-[#EE0000]/40'
    },
    fill: {
      'ink-blue': 'fill-blue-d dark:fill-white',
      'mid-blue': 'fill-blue-m dark:fill-white',
      white: 'fill-white',
      green: 'fill-[#008767]',
      red: 'fill-[#EE0000]'
    }
  },
  defaultVariants: {
    colour: 'ink-blue',
    fill: 'ink-blue'
  }
})

const TertiaryLink = ({
  data,
  colour,
  variant,
  className,
  onClick
}: Button) => {
  let btnColour =
    data?.strongColour && colour === 'ink-blue' ? 'mid-blue' : colour

  if (variant && data?.strongColour) {
    switch (variant) {
      case 'accept':
        btnColour = 'green'
        break
      case 'cancel':
        btnColour = 'red'
    }
  }

  if (variant) {
    return (
      <Link
        to={''}
        className={cn('unstyled-link group relative flex w-fit', className)}
        onClick={event => {
          if (onClick) {
            event.preventDefault() // Prevent the default link behavior
            onClick() // Call the provided onClick handler
          }
        }}
      >
        <div
          className={cn(
            buttonVariants({ colour: btnColour }),
            'mr-3xs gap-2xs pb-3xs group-hover:gap-2xs-plus group-focus:gap-2xs-plus flex items-center border-b-[1px] transition-all duration-200 group-hover:mr-0 group-focus:mr-0'
          )}
        >
          {variant === 'cancel' ? (
            <Close
              fill={btnColour}
              width={'1.25rem'}
              height={'1.25rem'}
              title={''}
            />
          ) : (
            <Check
              fill={btnColour}
              width={'1.437rem'}
              height={'1.437rem'}
              title={''}
            />
          )}
          {data?.label}
          <svg
            height='1'
            width='100%'
            className='absolute bottom-0 left-0 z-1 origin-left scale-x-0 transition-transform duration-200 group-hover:scale-x-100 group-focus:scale-x-100'
          >
            <rect
              x='0'
              y={1}
              width='100%'
              height='1'
              className={cn(
                buttonVariants({ fill: btnColour, colour: null }),
                ''
              )}
              strokeWidth='2'
              strokeLinecap='square'
            />
          </svg>
        </div>
      </Link>
    )
  }

  return (
    <a
      href={
        data?.internalLink?.sys?.uri
          ? data?.internalLink?.sys.uri
          : (data?.externalLink ?? '')
      }
      {...(data?.ariaLabel !== '' ? { 'aria-label': data?.ariaLabel } : {})}
      className={cn('unstyled-link group relative flex w-fit', className)}
      {...(data?.externalLink && data?.newWindow ? { target: '_blank' } : {})}
      {...(data?.externalLink && data?.newWindow
        ? { rel: 'noreferrer nofollow' }
        : {})}
    >
      <div
        className={cn(
          buttonVariants({ colour: btnColour }),
          'mr-3xs gap-2xs pb-3xs group-hover:gap-2xs-plus group-focus:gap-2xs-plus flex items-center border-b-[1px] transition-all duration-200 group-hover:mr-0 group-focus:mr-0'
        )}
      >
        {data?.mobileLabel ? (
          <>
            <span className='xl:hidden'>{data?.mobileLabel}</span>
            <span className='max-xl:hidden'>{data?.label}</span>
          </>
        ) : (
          <>{data?.label}</>
        )}
        {!data?.internalLink && data?.newWindow ? (
          <ArrowOut
            fill={btnColour}
            width={'1.25rem'}
            height={'1.25rem'}
            title={''}
          />
        ) : (
          <ArrowRight
            fill={btnColour}
            width={'1.437rem'}
            height={'1.437rem'}
            title={''}
          />
        )}

        <svg
          height='1'
          width='100%'
          className='absolute bottom-0 left-0 z-1 origin-left scale-x-0 transition-transform duration-200 group-hover:scale-x-100 group-focus:scale-x-100'
        >
          <rect
            x='0'
            y={1}
            width='100%'
            height='1'
            className={cn(
              buttonVariants({ fill: btnColour, colour: null }),
              ''
            )}
            strokeWidth='2'
            strokeLinecap='square'
          />
        </svg>
      </div>
    </a>
  )
}

export default TertiaryLink
